"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerWeightUnitsList = exports.convert = exports.conversionRates = exports.BushelTypesList = exports.AllWeightUnitsList = exports.WeightUnitsList = void 0;
const debug_1 = __importDefault(require("debug"));
const logger = (0, debug_1.default)("weight-units");
/**
 * List of all available weight units
 */
exports.WeightUnitsList = ["Bushel", "Kilogram", "Metric ton", "Short ton", "Pound"];
/**
 * List of all available expanded weight units
 */
exports.AllWeightUnitsList = ["Bushel", "Kilogram", "Metric ton", "Short ton", "Container"];
exports.BushelTypesList = ["Rye", "Oats", "Sorghum", "Corn", "Wheat", "Soybeans", "Flaxseed"];
exports.conversionRates = {
    Kilogram: {
        Kilogram: 1,
        "Metric ton": 0.001,
        "Short ton": 0.00110231,
        Pound: 2.20462,
    },
    "Metric ton": {
        Kilogram: 1000,
        "Metric ton": 1,
        "Short ton": 1.10231,
        Pound: 2204.62,
    },
    "Short ton": {
        Kilogram: 907.185,
        "Metric ton": 0.907185,
        "Short ton": 1,
        Pound: 2000,
    },
    Pound: {
        Kilogram: 0.45359702440352,
        "Metric ton": 0.00045359702440352,
        "Short ton": 0.0005,
        Pound: 1,
    },
};
const conversionRatesMetricTonnesToBushels = {
    Rye: 45.9296,
    Oats: 68.8944,
    Sorghum: 39.368,
    Corn: 39.368,
    Wheat: 36.7437,
    Soybeans: 36.7437,
    Flaxseed: 39.368,
};
function convert(value, from, to, product) {
    if (!(from === "Bushel" || to === "Bushel")) {
        logger.extend("convert")(`Converting %d of %s to %s using conversion rate of %d`, value, from, to, exports.conversionRates[from][to]);
        return value * exports.conversionRates[from][to];
    }
    if (!product) {
        throw new Error("Missing product type during bushel conversion");
    }
    logger.extend("convert")(`Converting %d of %s to %s using conversion rate of %d for product %s`, value, from, to, conversionRatesMetricTonnesToBushels[product], product);
    if (from === "Bushel") {
        // Convert bushel to metric tone
        const valueAsMetricTonnes = value / conversionRatesMetricTonnesToBushels[product];
        if (to === "Bushel") {
            throw new Error("Cannot convert between bushel types");
        }
        return valueAsMetricTonnes * exports.conversionRates["Metric ton"][to];
    }
    if (to === "Bushel") {
        // Convert to metric tone and to bushels
        const valueAsMetricTonnes = value * conversionRatesMetricTonnesToBushels[product];
        return valueAsMetricTonnes * exports.conversionRates[from]["Metric ton"];
    }
    throw new Error("Unknown conversion");
}
exports.convert = convert;
exports.ContainerWeightUnitsList = ["Kilogram", "Metric ton"];
